import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { startGateScreenPolling, useRemoteConfigStore } from '@/app/remote_config/handler/remoteConfigStore';
import { maintenanceMessageFor } from '@/app/remote_config/domain/remoteAppConfig';
import { useSettingsStore } from '@/settings/handler/settingsStore';
import { PixelContainer } from '@/ui/pixel/PixelContainer';
import { useThemeColors } from '@/settings/handler/settingsStore';

export function MaintenanceScreen() {
  const { t } = useTranslation();
  const colors = useThemeColors();
  const refresh = useRemoteConfigStore((s) => s.refresh);
  const [checking, setChecking] = useState(false);
  const locale = useSettingsStore((s) => s.locale);
  const message = useRemoteConfigStore((s) => {
    if (!s.config) return t('maintenanceDefaultMessage');
    return maintenanceMessageFor(s.config, locale, t('maintenanceDefaultMessage'));
  });

  const onCheckAgain = async () => {
    if (checking) return;
    setChecking(true);
    try {
      await refresh();
    } finally {
      setChecking(false);
    }
  };

  useEffect(() => startGateScreenPolling(), []);

  return (
    <div className="flex h-full items-center justify-center px-7" style={{ backgroundColor: colors.surface }}>
      <div className="flex w-full max-w-[420px] flex-col items-center">
        <h1 className="leading-none" style={{ fontSize: 40, color: colors.onSurface }}>
          {t('appName')}
        </h1>
        <div className="mt-7 w-full">
          <PixelContainer
            radius={3}
            pixelScale={2}
            padding="20px"
            backgroundColor={colors.surfaceContainerHighest}
            borderColor={colors.onSurface}
          >
            <h2 className="text-center leading-tight" style={{ fontSize: 28, color: colors.onSurface }}>
              {t('maintenanceTitle')}
            </h2>
            <p
              className="mt-3.5 text-center leading-snug"
              style={{ fontSize: 18, color: colors.onSurface, opacity: 0.75 }}
            >
              {message}
            </p>
            <div className="mt-5 h-0.5 w-full overflow-hidden" style={{ backgroundColor: colors.onSurface, opacity: 0.18 }}>
              <div className="h-full w-1/3 animate-pulse" style={{ backgroundColor: colors.onSurface }} />
            </div>
            <p
              className="mt-3.5 text-center leading-tight"
              style={{ fontSize: 16, color: colors.onSurface, opacity: 0.55 }}
            >
              {t('maintenanceHint')}
            </p>
          </PixelContainer>
        </div>
        <div className="mt-6 w-full">
          <PixelContainer
            radius={9}
            pixelScale={2}
            padding="14px 28px"
            backgroundColor={colors.surfaceContainerHighest}
            borderColor={colors.onSurface}
            onClick={checking ? undefined : () => void onCheckAgain()}
          >
            <span className="block text-center leading-none" style={{ fontSize: 22, color: colors.onSurface }}>
              {checking ? t('offlineChecking') : t('offlineRetry')}
            </span>
          </PixelContainer>
        </div>
      </div>
    </div>
  );
}
